import React from 'react';
import type { FormInputProps } from '../FormProps';
import { ErrorMessage } from '~/components/form-fields/ErrorMessage';
import { defaultClassName, Label } from '~/components/form-fields/Label';
import { classNames } from '~/components/utils';
import clsx from 'clsx';
import { FAIcon } from '~/components/utils/FAIcons';

export const TextInput = ({
	autoFocus,
	autoComplete = 'off',
	disabled,
	errorMessage,
	form,
	id,
	testId,
	labelText,
	subLabel,
	max,
	min,
	name,
	placeholder,
	preventMinus,
	required,
	register,
	type,
	step,
	labelClassName,
	valueAsNumber,
	onChangeFn,
	onKeyDown,
	tailingIcon,
	tailingIconOnClick,
	tailingText,
	leadingText,
	subText,
	className,
	onFocus,
	onBlur,
	labelButton,
	inputClassName,
	inputBorderColor = 'border-gray-400',
}: FormInputProps) => {
	const preventMinusPress = (e: any) => {
		if (e.code === 'Minus') {
			e.preventDefault();
		}
	};
	const errorId = id ? id + '-error' : undefined;
	return (
		<div className={className}>
			<div className="flex justify-between">
				{labelText && <Label id={id} className={clsx('mb-1', labelClassName ?? defaultClassName)} labelText={labelText} />}
				{labelButton && labelButton}
			</div>
			{subLabel && <p className={clsx('text-sm text-gray-700 mb-1', labelClassName ?? defaultClassName)}>{subLabel}</p>}
			<div className="relative">
				{leadingText && (
					<span className="pointer-events-none font-medium text-gray-500 absolute inset-y-0 left-0 flex items-center pl-3">
						{leadingText}
					</span>
				)}
				<input
					{...register(name, {
						valueAsNumber: !!valueAsNumber,
						onBlur,
						onChange: onChangeFn,
						required: required ? required : false,
					})}
					disabled={disabled}
					id={id}
					data-testid={testId}
					name={name}
					type={type ? type : 'text'}
					autoComplete={autoComplete}
					autoFocus={autoFocus}
					form={form}
					required={required}
					placeholder={placeholder}
					min={min}
					max={max}
					onFocus={onFocus}
					step={step ? step : 'any'}
					onKeyDown={onKeyDown ? (event) => onKeyDown(event) : null}
					onKeyPress={preventMinus ? preventMinusPress : undefined}
					className={classNames(
						inputClassName,
						leadingText ? 'pl-6' : '',
						tailingIcon ? 'pr-8' : '',
						disabled ? 'bg-gray-200' : '',
						`appearance-none block w-full px-3 py-2 border ${inputBorderColor} rounded-md shadow-xs placeholder-gray-400 focus:outline-hidden focus:ring-blue-500 focus:border-blue-500`
					)}
					// @ts-ignore blur type error
					onWheel={type === 'number' ? (e) => e.target.blur() : undefined}
				/>
				{tailingText && (
					<span
						className={`pointer-events-none font-medium text-gray-500 absolute inset-y-0 ${type === 'number' ? 'right-6' : 'right-0'} flex items-center pr-3`}
					>
						{tailingText}
					</span>
				)}
				{!!tailingIcon && (
					<button
						className={`absolute inset-y-0 right-0 flex items-center pr-2 ${tailingIconOnClick ? 'cursor-pointer' : 'cursor-default'}`}
						onClick={tailingIconOnClick}
						type="button"
					>
						<FAIcon icon={tailingIcon} />
					</button>
				)}
				{subText && <p className="text-sm mt-1">{subText}</p>}
			</div>
			{errorMessage && <ErrorMessage id={errorId} errorMessage={errorMessage} />}
		</div>
	);
};
